var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['cta-input', _vm.author]},[_c('v-btn',{attrs:{"disabled":_vm.state === 'done',"large":_vm.isMain,"outlined":!_vm.isMain,"rounded":"","color":"primary"},on:{"click":function($event){return _vm.handleClick()}}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }